import classNames from 'classnames'
import styles from './Tab.module.scss'
import type { TabProps } from './types'

const Tab = ({ onClick, onFocus ,onKeyDown, selected, tab }: TabProps) => {
  const { leadingAccessory, trailingAccessory, label } = tab
  return (
    <button
      aria-controls={tab.ariaControls}
      className={classNames(styles['pintxo-tab'])}
      data-selected={selected}
      id={tab.id}
      onClick={onClick}
      onKeyDown={onKeyDown}
      onFocus={onFocus}
      role="tab"
      type="button"
      {...(selected ? { tabIndex: 0 } : { tabIndex: -1 })}
    >
      <span className={classNames(styles['pintxo-tab__content'])}>
        {leadingAccessory && <span>{leadingAccessory}</span>}
        <span>{label}</span>
        {trailingAccessory && <span>{trailingAccessory}</span>}
      </span>
      <span className={styles['pintxo-tab__indicator']} />
    </button>
  )
}

export default Tab
